import React from 'react';
import { formatCurrency } from '../../lib/formatters';
import { participationSheetRows, formatSheetValue } from './participationSheetModel';

/** Josh's participation sheet for one participant (10/28) — rendered under the Allocation row. */
export default function ParticipationSheet({ computation, participant, name, terms }) {
  const rows = participationSheetRows(computation, participant, terms);
  return (
    <div className="inline-block min-w-[22rem] border border-slate-300 bg-white text-sm" data-testid="participation-sheet">
      {name && <div className="px-3 py-1.5 font-semibold border-b border-slate-300 bg-slate-50">{name}</div>}
      {rows.map(r => {
        const tone = r.tone === 'owed' ? 'bg-red-600 text-white' : r.tone === 'ledger' ? 'bg-emerald-500 text-white' : r.tone === 'gain' ? 'bg-blue-600 text-white' : '';
        return (
          <div key={r.key} className="grid grid-cols-[1fr_auto] border-b border-slate-200 last:border-b-0">
            <div className={`px-3 py-1 font-semibold ${r.tone ? 'bg-slate-50' : ''}`}>{r.label}</div>
            <div className={`px-3 py-1 text-right font-semibold min-w-[8rem] ${tone}`}>
              {formatSheetValue(r, formatCurrency)}
              {r.note && <div className="text-xs font-normal opacity-90">{r.note}</div>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
